/**
 * Auvé slide cart.
 * - Opens from the header cart icon (any link to /cart) and after add to cart.
 * - Adds / changes items with Shopify's AJAX Cart API and re-renders the drawer with the
 *   Section Rendering API, so all markup and pricing come from Liquid (sections/auve-cart-drawer.liquid).
 */
(function () {
  if (window.AuveCart) return;

  var SECTION = 'auve-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;

  function drawer() {
    return document.querySelector('[data-auve-cart]');
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function render(html) {
    var el = drawer();
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-auve-cart-body]');
    var current = el.querySelector('[data-auve-cart-body]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateBubble(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    }
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count === 0);
      var num = bubble.querySelector('.cart-bubble__text-count');
      if (num) {
        num.textContent = count > 0 && count < 100 ? String(count) : '';
        num.classList.toggle('hidden', count === 0);
      }
    });
  }

  function setBusy(on) {
    var el = drawer();
    if (el) el.classList.toggle('is-busy', on);
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data[SECTION]); })
      .catch(function () {});
  }

  function open() {
    var el = drawer();
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('auve-cart-open');
    var panel = el.querySelector('.auve-cart__panel');
    setTimeout(function () {
      var close = el.querySelector('.auve-cart__close');
      (close || panel).focus({ preventScroll: true });
    }, 50);
  }

  function close() {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('auve-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function change(key, quantity) {
    setBusy(true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) render(data.sections[SECTION]);
        else if (data.description) alert(data.description);
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () { setBusy(false); });
  }

  function add(form, button) {
    var body = new FormData(form);
    body.append('sections', SECTION);
    body.append('sections_url', window.location.pathname);
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          alert(res.data.description || res.data.message || 'Sorry, this item could not be added.');
          return;
        }
        if (res.data.sections) render(res.data.sections[SECTION]);
        else return refresh();
      })
      .then(function () { open(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }

  // Header cart icon + any link to the cart page opens the drawer instead.
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || isCartPage() || !drawer()) return;
      if (link.closest('[data-auve-cart]')) return;
      var url;
      try { url = new URL(link.href, window.location.origin); } catch (err) { return; }
      if (url.origin !== window.location.origin || !/\/cart\/?$/.test(url.pathname)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open();
      refresh();
    },
    true
  );

  // Drawer controls (close, quantity, remove, upgrade).
  document.addEventListener('click', function (e) {
    var el = drawer();
    if (!el || !el.contains(e.target)) return;
    if (e.target.closest('[data-auve-cart-close]')) {
      close();
      return;
    }
    var btn = e.target.closest('[data-auve-cart-qty]');
    if (btn) {
      var item = btn.closest('[data-key]');
      if (item) change(item.getAttribute('data-key'), Math.max(0, parseInt(btn.getAttribute('data-auve-cart-qty'), 10) || 0));
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var focusables = el.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Product forms that post to /cart/add (unless another script already handled them).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !drawer() || !form || !form.action) return;
    if (!/\/cart\/add\/?$/.test(new URL(form.action, window.location.origin).pathname)) return;
    e.preventDefault();
    add(form, e.submitter || form.querySelector('[type="submit"]'));
  });

  // Keep the drawer in sync when the theme's own cart code changes the cart.
  document.addEventListener('shopify:cart:lines-update', function () { refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.AuveCart = { open: open, close: close, refresh: refresh };
})();
